import React, {Component} from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import portrait from '../images/portrait.jpg';
import '../styles/About.less';
import { Link } from 'react-router'

export default class About extends Component {
    render() {
        return (
            <div id="about" className="card transition-item">
                <header className="bg-primary-violet">
                    <h1>Über mich</h1>
                </header>

                <Row>
                    <Col sm={9}>
                        <div className="cv-head">
                            <Image circle={true} src={portrait} className="profile-image"/>
                            <h3>Kateryna Byelousova</h3>
                            <h4>Musikpädagogin, M.A.</h4>
                            <p className="location text-muted">
                                <i className="fp fp-location"/> München
                            </p>
                            <h3>Profil</h3>
                            <p>Kateryna Byelousova, M.A. absolvierte von 1995-2000 das staatl. Konservatorium in Odessa mit Fachrichtung Klavier und schloss dieses mit Auszeichnung als Konzert- und Solopianistin, Pianistin für Kammerensemble, Korrepetition und Musiklehrerin ab.
                            </p>
                            <p>
                                Im Jahr 2000 erwarb sie das Magisterdiplom in Musikwissenschaften am Konservatorium in Odessa.
                                Im Jahr 2008 schloss sie das Studium der Musikpädagogik an der LMU München mit sehr gutem Erfolg ab.</p>
                            <p>
                                In Odessa war sie seit 2000 an der Musikschule in Odessa als Lehrerin und Korrepetitorin tätig. In München unterrichtet sie seit 2001 Kinder und Erwachsene im Fach Klavier und ist weiterhin als Pianistin und Korrepetitorin sowie im Ensemblebereich konzertierend tätig.</p>
                            <Link to="/contact" className="btn btn-primary">Jetzt Probestunde vereinbaren</Link>
                        </div>

                        <div className="cv-block">
                            <h3><i className="fp fp-note"/> Berufserfahrung</h3>
                            <ol className="list-unstyled">
                                <li>
                                    <div className="experience-block">
                                        <h4>Musikpädagogin</h4>
                                        <div className="timestamp">
                                            seit 2008
                                        </div>
                                        <div className="location">
                                            Freiberuflich tätig
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Musikpädagogin</h4>
                                        <div className="timestamp">
                                            2008 - 2012
                                        </div>
                                        <div className="location">
                                            Piano-Mobil - private Musikinitiative, München
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Musikpädagogin</h4>
                                        <div className="timestamp">
                                            2003 - 2008
                                        </div>
                                        <div className="location">
                                            Studienbegleitend tätig
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Gesangsbegleitung für Konzertauftritte</h4>
                                        <div className="timestamp">
                                            seit 2002
                                        </div>
                                        <div className="location">
                                            Gesangsensemble Arioso
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Korrepetitorin</h4>
                                        <div className="timestamp">
                                            2000 - 2001
                                        </div>
                                        <div className="location">
                                            Staatskonservatorium A. W.Neshdanowa, Odessa
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Klavierlehrerin und Korrepetitorin</h4>
                                        <div className="timestamp">
                                            2000 - 2001
                                        </div>
                                        <div className="location">
                                            Glasunow Musikschule N22, Odessa
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>

                        <div className="cv-block">
                            <h3><i className="fp fp-graduate"/> Ausbildung</h3>
                            <ol className="list-unstyled">
                                <li>
                                    <div className="experience-block">
                                        <h4>Magister Artium</h4>
                                        <div className="timestamp">
                                            2003 - 2008
                                        </div>
                                        <div className="location">
                                            Ludwig-Maximilians-Universität, München
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Magisterdiplom mit Auszeichnung</h4>
                                        <div className="timestamp">
                                            1999 - 2000
                                        </div>
                                        <div className="location">
                                            Staatskonservatorium A. W.Neshdanowa, Odessa
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="experience-block">
                                        <h4>Fachmannsdiplom mit Auszeichnung</h4>
                                        <div className="timestamp">
                                            1995 - 2000
                                        </div>
                                        <div className="location">
                                            Staatskonservatorium A. W.Neshdanowa, Odessa
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </Col>

                    <Col sm={3} className="text-justify">
                        <div className="experience-block">
                            <h3><i className="fp fp-music"/> Leistungen</h3>
                            <ul className="list-unstyled list-keywords">
                                <li>Klavierbegleitung</li>
                                <li>Korrepetition</li>
                                <li>Vorbereitung / Klavierbegleitung bei Wettbewerben</li>
                                <li>Vorbereitung Musik Additum (Klavier)</li>
                                <li>Musikalische Umrahmung für Events</li>
                                <li>Gehörbildung</li>
                                <li>Musiktheorie</li>
                                <li>Musik Garten</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/About.js